export default {
  addMailBoxes: "addMailBoxes",
  addUser: "addUser",
  addTeams: "addTeams",
  removeModal: "removeModal",
};